import { generatePath } from 'react-router';
import { takeLatest, select, call, takeEvery } from 'redux-saga/effects';

import { PATH } from 'constants/RoutesConstants';
import { putAndWait } from 'modules/app/sagas';
import { scopeToPage } from 'modules/app/sagas/utils';
import { fetchReleases } from 'modules/releases/actions/core';
import * as types from 'modules/releases/actionTypes';
import { getBaseRequestParams } from 'modules/releases/selectors/dashboard';
import { navigate } from 'modules/router/navigate';

import { DASHBOARD_SOURCE } from '../constants';

/**
 * Handles successful release creation by redirecting to details
 * @param {CreateReleaseSuccessAction} action
 */
function* handleCreateReleaseSuccess(action) {
  const { id: releaseId } = action.payload;
  // Navigate to the release details page
  const detailsPath = generatePath(PATH.RELEASES_DETAILS.path, { releaseId });
  yield call(navigate, detailsPath);
}

function* fetchReleasesWithFilters() {
  const params = yield select(getBaseRequestParams);
  yield putAndWait(fetchReleases(params, { source: DASHBOARD_SOURCE }));
}

function* handleFilterChange() {
  const params = yield select(getBaseRequestParams);
  yield putAndWait(fetchReleases({ ...params, page: 0 }, { source: DASHBOARD_SOURCE }));
}

function* initializeReleasesDashboard() {
  yield call(fetchReleasesWithFilters);
  yield takeEvery(types.CREATE_RELEASE_SUCCESS, handleCreateReleaseSuccess);

  yield takeLatest([
    types.SET_RELEASES_DASHBOARD_FILTER,
    types.SET_RELEASES_DASHBOARD_FILTERS,
    types.REMOVE_RELEASES_DASHBOARD_FILTER,
    types.CLEAR_RELEASES_DASHBOARD_FILTERS,
  ], handleFilterChange);
}

export default function* dashboardSaga() {
  yield scopeToPage([PATH.RELEASES_DASHBOARD], initializeReleasesDashboard);
}
